/**
 * Cookie Banner – Custom Content Override
 * Replaces Shopify's native cookie banner text/buttons with
 * taste-profile-specific messaging (EN + NL).
 */
(function () {
  var CONSENT_STORAGE_KEY = 'vinpop_cookie_consent_choice';
  var CONSENT_ACCEPTED = 'accepted';
  var CONSENT_DECLINED = 'declined';

  var TEXTS = {
    en: {
      title: 'Cookies & Privacy',
      body: 'We use cookies to enhance your experience and analyze site performance. By continuing, you accept our use of cookies.',
      accept: 'Accept',
      decline: 'Decline'
    },
    nl: {
      title: 'Cookies & Privacy',
      body: 'We gebruiken cookies om je ervaring te verbeteren. Door door te gaan, accepteer je onze cookies.',
      accept: 'Accepteren',
      decline: 'Weigeren'
    }
  };

  function getLang() {
    var html = document.documentElement.lang || '';
    if (html.indexOf('nl') === 0) return 'nl';
    return 'en';
  }

  function persistLocalConsent(accepted) {
    try {
      var choice = accepted ? CONSENT_ACCEPTED : CONSENT_DECLINED;
      localStorage.setItem(CONSENT_STORAGE_KEY, choice);
      sessionStorage.setItem(CONSENT_STORAGE_KEY, choice);
    } catch (e) { /* silent */ }
  }

  function getLocalConsent() {
    try {
      return localStorage.getItem(CONSENT_STORAGE_KEY) || sessionStorage.getItem(CONSENT_STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setConsent(accepted, done) {
    persistLocalConsent(accepted);

    var consentPayload = accepted
      ? { analytics: true, marketing: true, preferences: true, sale_of_data: true }
      : { analytics: false, marketing: false, preferences: false, sale_of_data: false };

    try {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent(consentPayload, function () {
          if (typeof done === 'function') done();
        });
        return;
      }
    } catch (e) { /* silent */ }

    if (typeof done === 'function') done();
  }

  function hideBanner(banner) {
    banner.style.display = 'none';
    // Also try parent wrapper
    var parent = banner.closest('.shopify-cleanslate');
    if (parent) parent.style.display = 'none';
  }

  var applied = false;

  function renderFullBanner(banner, t) {
    banner.classList.remove('vinpop-cookie-compact');
    banner.classList.add('vinpop-cookie-full');

    banner.innerHTML =
      '<div class="vinpop-cookie-inner">' +
        '<div class="vinpop-cookie-title">' + t.title + '</div>' +
        '<p class="vinpop-cookie-body">' + t.body + '</p>' +
        '<div class="vinpop-cookie-buttons">' +
          '<button class="vinpop-cookie-accept" type="button">' + t.accept + '</button>' +
          '<button class="vinpop-cookie-decline" type="button">' + t.decline + '</button>' +
        '</div>' +
      '</div>';

    banner.querySelector('.vinpop-cookie-accept').addEventListener('click', function () {
      setConsent(true, function () {
        hideBanner(banner);
      });
    });

    banner.querySelector('.vinpop-cookie-decline').addEventListener('click', function () {
      setConsent(false, function () {
        hideBanner(banner);
      });
    });
  }

  function customizeBanner() {
    if (applied) return;
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;

    var storedConsent = getLocalConsent();

    // Hide banner if already accepted or declined
    if (storedConsent === CONSENT_ACCEPTED || storedConsent === CONSENT_DECLINED) {
      applied = true;
      hideBanner(banner);
      return;
    }

    // Show single banner for all pages
    applied = true;
    var t = TEXTS[getLang()];
    renderFullBanner(banner, t);
  }

  // Poll until Shopify renders the banner
  var attempts = 0;
  function poll() {
    if (applied || attempts > 50) return;
    attempts++;
    customizeBanner();
    if (!applied) setTimeout(poll, 200);
  }

  poll();

  // Also hook into load event
  window.addEventListener('load', function () {
    setTimeout(poll, 500);
    setTimeout(poll, 2000);
  });

  // MutationObserver as final fallback
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function () {
      if (!applied) customizeBanner();
      if (applied) obs.disconnect();
    });
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
